// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2_JCwJ5BuG9yCrQneEZm"};